import {showErrorMessage} from "@/helper";

export default {
    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/contract-types/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAll(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/contract-types' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getActive(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/contract-types/active' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAllActive(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/contract-types/active' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getContractType(id, style = null) {
        return new Promise((resolve, reject) => {
            http.get('api/contract-types/' + id + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveContractType(data, contractTypeId = null) {
        return new Promise((resolve, reject) => {
            http.post('api/contract-types' + (contractTypeId ? '/' + contractTypeId : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteContractType(contractType) {
        return new Promise((resolve, reject) => {
            http.delete('api/contract-types/' + contractType).then(response => {
                resolve(response.data);
            }).catch(error => {
                showErrorMessage(error.response.data.message);
                //reject([]);
            });
        });
    },
}
